(function($) {
  var TableBulk = function(element, options) {
    let settings = $.extend(
      {
        url: null,
        urlRemove: null
      },
      options || {}
    );
    // const queryString = require("query-string");

    const btnGroupTemplate = `
      <div class="btn-group mr-2 btn-group-bulk-actions" role="group">
          <div class="input-group">
              <div class="input-group-prepend">
                  <div class="input-group-text" style="background-color: #FFFFFF; ">
                    <span class="checkbox-text"></span>
                  </div>
              </div>
          </div>
      </div>`;

    /*
     * Public method
     * Can be called outside class
     */
    this.capture = () => {
      const obj = this;

      $("#container").on("update.check-row-all", ".check-row-all", function(
        evt
      ) {
        obj.updateCheckAllCheckbox($(this));
        updateBulkActionLinks($(this));
      });

      $("#container").on("click", ".check-row-all", function(evt) {
        let $tr = $(this).closest("tr");

        if ($(this).is(":checked")) {
          $tr
            .closest("table")
            .find(".check-row")
            .prop("checked", true);
        } else {
          $tr
            .closest("table")
            .find(".check-row")
            .prop("checked", false);
        }

        obj.updateCheckAllCheckbox($(this));
        updateBulkActionLinks($(this));
      });

      $("#container").on("click", ".check-row", function(evt) {
        obj.updateCheckAllCheckbox(
          $(this)
            .closest("table")
            .find(".check-row-all:first")
        );

        updateBulkActionLinks($(this));
      });

      $(".check-row-all").each((index, elem) => {
        obj.updateCheckAllCheckbox($(elem));
      });

      $("#container").on("click", ".select-all-selectable", function(evt) {
        const checkboxCount = $(this).closest('.checkbox-text').find(".checked-count:first");

        checkboxCount.text($(this).attr('data-count'));

        $(this)
          .closest(".bulk-actionable")
          .find(".btn-group-bulk-actions .bulk-action")
          .attr("data-select-all-count", $(this).attr('data-count'));

        $(this).hide();
      });

      // $("#container").on("click", ".bulk-action", function(evt) {
      //   const ids = $(this)
      //     .closest("table")
      //     .find(".check-row:checked")
      //     .map((index, elem) => $(elem).data("id"))
      //     .get();
      //
      //   // console.log(ids, "ids");
      //
      //   $dataHref = $(this).data("href");
      //
      //   let parsedUrl = queryString.parseUrl($dataHref);
      //
      //   parsedUrl.query = {
      //     ...parsedUrl.query,
      //     ids: ids.join(",")
      //   };
      //
      //   let url = `${parsedUrl.url}?${queryString.stringify(parsedUrl.query)}`;
      //
      //   console.log(url);
      //
      //   // $(this).attr("data-href", url);
      // });
    };

    // bindBtnGroups = () => {
    //   let $btnGroup = $(btnGroupTemplate);
    //
    //   $('.check-row-all').each(function (index, elem) {
    //     $btnGroup.append($('.table-bulk-actions-main:first').html());
    //   });
    //
    //
    // };
    updateBulkActionLinks = $checkbox => {
      const ids = $checkbox
        .closest("table")
        .find(".check-row:visible:checked")
        .map((index, elem) => $(elem).data("id"))
        .get();

      const ids2 = $checkbox
        .closest("table")
        .find(".check-row:visible:checked")
        .map((index, elem) => $(elem).data("id2"))
        .get();

      $checkbox
        .closest(".bulk-actionable")
        .find(".btn-group-bulk-actions .bulk-action")
        .attr("data-selected-ids", ids.join(","))
        .attr("data-selected-ids2", ids2.join(","));
    };

    this.updateCheckAllCheckbox = $checkboxAll => {
      let $th = $checkboxAll.closest("th");
      let $tr = $th.closest("tr");
      let $checkbox = $checkboxAll.closest(".custom-checkbox");
      let checkedCount = $checkboxAll
        .closest("table")
        .find(".check-row:visible:checked").length;
      const selectableTotalRows = $checkboxAll.attr("data-selectable-total-rows");
      const btnSelectEverything = !isNaN(selectableTotalRows) ?
        $(`<button type="button" class="btn btn-link btn-sm py-0 px-1 ml-2 select-all-selectable" data-count="${selectableTotalRows}">
            Select all ${selectableTotalRows} documents</button>`) : null;

      if (checkedCount > 0) {
        if (!$checkboxAll.closest(".btn-group-bulk-actions").length) {
          let $btnGroup = $(btnGroupTemplate);

          if ($($checkboxAll.data("btn-group-target")).length)
            $btnGroup.append($($checkboxAll.data("btn-group-target")).html());

          $btnGroup.find(".input-group-text:first").prepend($checkbox);
          $th.attr("colspan", $tr.find("th").length).prepend($btnGroup);

          $tr.find("th").hide();
          $th.addClass("pl-0").show();
        }

        $th.find(".checkbox-text").html(`<span class="checked-count">${checkedCount}</span> selected`).append(btnSelectEverything);

        if (
          checkedCount < $checkboxAll.closest("table").find(".check-row").length
        ) {
          $checkboxAll.prop("indeterminate", true);
        }
      } else {
        $th
          .removeAttr("colspan")
          .removeClass("pl-0")
          .html($checkbox);

        $checkboxAll.prop("indeterminate", false);
        $tr.find("th").show();
      }
    };
  };

  $.tableBulk = function(options) {
    return new TableBulk(null, options);
  };
})(jQuery);
